import styled from 'styled-components';
import {
  flexWrap,
  FlexWrapProps,
  flexDirection,
  FlexDirectionProps,
  alignItems,
  AlignItemsProps,
  justifyContent,
  JustifyContentProps
} from 'styled-system';
import { rowGap, columnGap } from 'src/helpers';
import { Box, BoxProps } from './Box';

export type FlexProps = BoxProps & FlexWrapProps & FlexDirectionProps & AlignItemsProps & JustifyContentProps;

export const Flex = styled(Box)<FlexProps>(flexDirection, flexWrap, justifyContent, alignItems);
Flex.defaultProps = {
  display: 'flex'
};

export const Column = styled(Flex)`
  flex-direction: column;
`;

export const Stack = styled(Flex)<{ rowGap?: any; columnGap?: any }>`
  &:not(:first-child) {
    ${rowGap};
    ${columnGap};
  }
`;
